import get from 'lodash/get';
import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import size from 'lodash/size';

export const loggedUserSelector = state => get(state, 'context.loggedUser');

export const loggedUserIdSelector = state =>
  get(state, 'context.loggedUser.id');
export const loggedUserEmployeeIdSelector = state =>
  get(state, 'context.loggedUser.employeeProfile.id');
export const targetUserEmployeeIdSelector = state =>
  get(state, 'context.targetUser.employeeProfile.id');
export const loggedUserCountrySelector = state =>
  get(state, 'context.loggedUser.country');
export const loggedUserStateSelector = state =>
  get(state, 'context.loggedUser.state');
export const hasPatientProfileSelector = state =>
  !!get(state, 'context.loggedUser.primaryPatientProfile');
// IS LOGGED USER PROVIDER
export const hasProviderProfileSelector = state =>
  !!get(state, 'context.loggedUser.primaryProviderProfile');
export const providerProfileIdSelector = state =>
  get(state, 'context.loggedUser.primaryProviderProfile.id');
export const isLoggedUserSelector = state =>
  get(state, 'context.permissions.isLoggedUser');
export const isCaregiverSelector = state =>
  get(state, 'context.permissions.isCaregiver');

export const editableForProvider = state =>
  get(state, 'context.targetUser.editableForProvider');

export const selectDashboardAccessible = createSelector(
  loggedUserSelector,
  state => get(state, 'dashboardAccessible', false),
);
export const selectDashboardVisible = createSelector(
  loggedUserSelector,
  state => get(state, 'dashboardVisible', false),
);
export const selectSeenSocialChatAlert = createSelector(
  loggedUserSelector,
  state => get(state, 'settings.seenSocialChatAlert', false),
);

// Dublicated with targetUserSelector
const selectTargeUserState = state => get(state, 'context.targetUser');

export const selectTargetProviderId = createSelector(
  selectTargeUserState,
  state => get(state, 'primaryProviderProfile.id'),
);

export const canEditNotJoinedPatient = state => editableForProvider(state);

export const canEditPatient = state =>
  isCaregiverSelector(state) ||
  isLoggedUserSelector(state) ||
  selectIsVerifiedDependentRole(state);

export const isFamilyMemberUserSelector = state =>
  get(state, 'context.permissions.isFamilyMemberOnly');

export const targetUserSelector = state => get(state, 'context.targetUser');

export const targetUserCountrySelector = state =>
  get(state, 'context.targetUser.country');

export const targetUserIdSelector = state =>
  parseInt(get(state, 'context.targetUserId'), 10);

export const targetUserPermissionsSelector = state =>
  get(state, 'context.permissions');

export const selectVerifiedDependentsList = state =>
  get(state, 'context.permissions.dependentsList', []);

export const selectIsVerifiedDependentRole = state =>
  get(state, 'context.permissions.isVerifiedDependent');

export const selectTargetUserSkipInsurance = state =>
  get(state, 'context.targetUser.skipInsurance', false);

export const selectTargetUserOrganizations = state =>
  get(state, 'context.targetUser.userOrganizations', []);

export const supportInfoSelector = state =>
  get(state, 'data.constants.supportInfo', {});

export const selectIsVerifiedGuardianRole = createSelector(
  selectVerifiedDependentsList,
  isLoggedUserSelector,
  (list, isLoggedUser) => {
    return isLoggedUser && !isEmpty(list);
  },
);

export const selectLoggedProviderProfile = state =>
  get(state, 'context.loggedUser.primaryProviderProfile');

export const selectLoggedProviderOrganizationCode = createSelector(
  selectLoggedProviderProfile,
  state => get(state, 'mrns[0].organization.code', null),
);

export const selectLoggedProviderTeamsList = createSelector(
  selectLoggedProviderProfile,
  profile => get(profile, 'teams', []),
);

export const selectIsTeamMemberProvider = createSelector(
  selectLoggedProviderTeamsList,
  list => Boolean(size(list)),
);

export const selectTeamUser = state => get(state, 'context.teamUser.user');

export const selectTeamUserId = createSelector(
  selectTeamUser,
  user => get(user, 'id'),
);

export const selectTeamId = state =>
  get(state, 'context.teamUser.selectedTeamId');

export const selectUserToShow = createSelector(
  loggedUserSelector,
  selectTeamUser,
  (loggedUser, teamUser) => {
    return teamUser || loggedUser;
  },
);

export const selectIdUserToShow = createSelector(
  selectUserToShow,
  user => get(user, 'id'),
);

export const selectIsLoggedTeam = createSelector(
  selectTeamId,
  id => Boolean(id),
);

export const selectShowOwnProviderProfile = createSelector(
  loggedUserIdSelector,
  targetUserSelector,
  (loggedUserId, targetUser) => {
    const { id, primaryProviderProfile } = targetUser;
    return primaryProviderProfile && id === loggedUserId;
  },
);



// WEBPACK FOOTER //
// ./src/redux/context/selectors.js